import SessionStorage from "../../../../../../../../utils/SessionStorage";

/**
 * If a Program Code exists in the offer, then it is added to session storage
 */
export default function setSelectedProgramCode(ProgramRates: any) {
    if (ProgramRates) {
        const { ProgramCode = '' } = ProgramRates;

        if (ProgramCode) {
            SessionStorage.set(
                'selectedProgramCode',
                ProgramCode,
            );
        }
    }
}